type BuyerLike = {
  can_manage_credit_card?: boolean;
  credit_card_last_numbers?: string | null;
};

/**
 * A buyer may manage a credit card when an admin has granted access, or when a card
 * already exists on the account — an existing card must always stay replaceable.
 */
export const canManageCreditCard = (buyer?: BuyerLike | null): boolean =>
  Boolean(buyer?.can_manage_credit_card || buyer?.credit_card_last_numbers);
